import Vue from 'vue';
import NewsContainer from './news-container';

export default new Vue({
    components: { NewsContainer },
    data () {
        return {
            data: {
                loading: false,
                results: [],
                total: 0,
                error: null,
            }
        }
    },
    render (h) {
        return h(NewsContainer, {
            props: this.data,
            on: {
                'load-more': this.loadMore,
            }
        })
    },
    methods: {
        loadMore ($event) {
            this.$emit('load-more', $event);
        }
    }
});
